// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__QjM3-","range":"MonthRangeSwitch_range__31QIZ","disabled":"MonthRangeSwitch_disabled__1hjr2"};